import {
  PATCH_PASSWORD,
  DISMISS_MESSAGES,
  SET_SAVED,
  SAVING_PASSWORD,
  SENDING_MAIL,
  SEND_MAIL,
  GET_TOKEN_STATUS,
} from './AUPasswordActions';

export const initialState = {
  password: {
    saving: false,
    saved: false,
    validToken: true,
  },
  messages: [],
};

export const reducer = (state = initialState, action) => {
  const nextState = { ...state };

  switch (action.type) {
    case DISMISS_MESSAGES: {
      nextState.messages = [];
      return nextState;
    }
    case SET_SAVED: {
      const prevPassword = { ...nextState.password };
      nextState.password = Object.assign(prevPassword, {
        saved: false,
      });
      return nextState;
    }
    case SENDING_MAIL:
    case SAVING_PASSWORD: {
      const prevPassword = { ...nextState.password };
      nextState.password = Object.assign(prevPassword, { saving: true, saved: false });
      return nextState;
    }
    case SEND_MAIL:
    case PATCH_PASSWORD: {
      const { result } = action;
      const prevPassword = { ...nextState.password };
      if (result.password) {
        nextState.password = Object.assign(prevPassword, {
          saving: false,
          saved: true,
        });
      } else if (result.error) {
        const {
          errorType,
          errorMessageDa,
          errorMessageEn,
          lang,
        } = result.error;
        nextState.messages = [{
          type: errorType,
          message: lang === 'da' ? errorMessageDa : errorMessageEn,
        }];
        nextState.password = Object.assign(prevPassword, { saving: false });
      }
      return nextState;
    }
    case GET_TOKEN_STATUS: {
      const { result } = action;
      const prevPassword = { ...nextState.password };
      nextState.password = Object.assign(prevPassword, {
        validToken: result.token,
      });

      return nextState;
    }
    default: {
      return null;
    }
  }
};
